module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0082.jpg?v=e03429ed";